import axiosClient from './axiosClient';

/**
 * Sát hạch & bảo lưu hồ sơ — đọc từ uniapp-backend (`/v2/kqsh`).
 *
 * Chỉ ĐỌC. Việc nhập file kết quả nằm ở uniapp-frontend (`/admin/getfly/kqsh`)
 * vì nút đồng bộ sang GetFly sau này ở đó; backend cũng chặn ghi với vai trò
 * giáo viên. Ở đây chỉ cần trả lời một câu: hồ sơ học viên này còn hạn thi lại
 * không.
 *
 * Quyền đọc: ADMIN, DRIVING.ADMIN, DRIVING.TEACHER, DRIVING.REPORTER — khớp
 * với AdminDrivingGuard, nên mọi trang sau guard đó gọi được.
 */

const API = '/v2/kqsh';

/**
 * Tra cứu danh sách.
 * @param {Object} p { q, nhomHang, daDat, canXemLai, chiVang, hetHanTruoc, page, limit }
 */
const getRetention = (params = {}) => axiosClient.get(`${API}/retention`, { params });

/**
 * Tra cứu đúng MỘT học viên theo CCCD.
 *
 * Backend tìm mờ theo tên/CCCD nên có thể trả nhiều dòng; ở đây lọc lại cho
 * khớp tuyệt đối. Trả `null` khi không có — nghĩa là "chưa nhập dữ liệu sát
 * hạch của người này", KHÁC với "người này không còn hạn". Chỗ gọi phải phân
 * biệt hai câu đó, đừng hiển thị thiếu dữ liệu thành hết hạn.
 */
const getRetentionByCccd = async (cccd) => {
  const so = String(cccd || '').replace(/\D/g, '');
  if (!so) return null;
  const res = await getRetention({ q: so, limit: 5 });
  const docs = res?.data?.docs || [];
  return docs.find((d) => d.cccd === so || d.soGiayTo === so) || null;
};

const kqshService = { getRetention, getRetentionByCccd };

export default kqshService;
